document.addEventListener('DOMContentLoaded', function() {
    const input = document.querySelector('#Search-In-Modal');
    const details = document.querySelector('.header-bottom--wrapper .search_details');
    
    if (!input) return;
    
    function showDropdown() {
        document.querySelectorAll('.header-bottom--wrapper .quickSearchResultsWrap').forEach(function(w) {
            w.classList.add('is-show');
        });
        if (details) details.open = true;
    }
    
    function hideDropdown() {
        document.querySelectorAll('.header-bottom--wrapper .quickSearchResultsWrap').forEach(function(w) {
            w.classList.remove('is-show');
        });
        if (details) details.open = false;
    }
    
    input.addEventListener('focus', showDropdown);
    input.addEventListener('input', showDropdown);
    input.addEventListener('click', showDropdown);
    
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.header__search')) {
            hideDropdown();
        }
    });
});